import { useQuery } from "@tanstack/react-query";
import { companiesService } from "@/services/companiesService";

/**
 * useCompanies hook fetches and returns the list of companies.
 */

// query keys
export const companiesQueryKeys = {
  all: ["companies"],
  list: () => [...companiesQueryKeys.all, "list"],
  details: (id) => [...companiesQueryKeys.all, "detail", id],
};

// get all companies
export const useCompanies = (params) => {
  return useQuery({
    queryKey: companiesQueryKeys.list(),
    queryFn: async () => {
      const response = await companiesService.getAllCompanies(params);
      return response.data; // Ensure this is an array
    },
  });
};

// get company by id
export const useCompanyById = (id, options = {}) => {
  return useQuery({
    queryKey: companiesQueryKeys.details(id),
    queryFn: () => companiesService.getCompanyById(id),
    enabled: !!id,
    ...options
  });
};

// get company by slug
export const useCompanyBySlug = (slug) => {
  return useQuery({
    queryKey: [...companiesQueryKeys.all, "slug", slug],
    queryFn: () => companiesService.getCompanyBySlug(slug),
    enabled: !!slug,
  });
};

// delete company
export const useDeleteCompany = (id) => {
  return useMutation({
    mutationFn: () => companiesService.deleteCompany(id),
    
  });
};

// get campaign by company id pass params
export const useGetCompaniesList = (params) => {
  return useQuery({
    queryKey: companiesQueryKeys.list(),
    queryFn: () => companiesService.getCompaniesList(params),
    // enabled: !!params,
  });
};

// export const useCompanies = () => {
//   return useQuery({
//     queryKey: ['companies'],
//     queryFn: async () => {
//       const response = await companiesService.getAllCompanies();
//       // Return the companies array from the 'data' property
//       return response.data;
//     },
//   });
// }; 


